import { render, staticRenderFns } from "./OfferServicesList.vue?vue&type=template&id=7dd1cf7b&scoped=true&"
import script from "./OfferServicesList.vue?vue&type=script&lang=js&"
export * from "./OfferServicesList.vue?vue&type=script&lang=js&"
import style0 from "./OfferServicesList.vue?vue&type=style&index=0&id=7dd1cf7b&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7dd1cf7b",
  null
  
)

export default component.exports